import { KeywordFromStore } from '@/types/types';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface KeywordsStoreState {
  keywords: KeywordFromStore[];
  isFirstBatch: boolean;
  totalItems: number;
  setKeywords: (
    keywords: KeywordFromStore[] | ((keywords: KeywordFromStore[]) => KeywordFromStore[]),
  ) => void;
  setTotalItems: (totalItems: number) => void;
  page: number;
  setPage: (page: number | ((page: number) => number)) => void;
  isSearching: boolean;
  setIsSearching: (isSearching: boolean) => void;
  searchTotalItems: number;
  setSearchTotalItems: (searchTotalItems: number) => void;
}

export const useKeywordsStore = create(
  devtools<KeywordsStoreState>((set) => ({
    keywords: [],
    setKeywords: (keywords) =>
      set((state) => {
        if (typeof keywords === 'function') {
          return {
            keywords: keywords(state.keywords),
          };
        }
        return {
          keywords,
        };
      }),
    searchTotalItems: 0,
    setSearchTotalItems: (searchTotalItems) => set({ searchTotalItems }),
    isFirstBatch: true,
    setTotalItems: (totalItems) => set({ totalItems }),
    totalItems: 0,
    page: 1,
    isSearching: false,
    setIsSearching: (isSearching) => set({ isSearching }),
    setPage: (page) =>
      set((state) => {
        if (typeof page === 'function') {
          return {
            page: page(state.page),
          };
        }
        return {
          page,
        };
      }),
  })),
);
